import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "priceshow"
}
const _hoisted_2 = { class: "priceshow__container" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "priceshow__results" }
const _hoisted_5 = { class: "priceshow__products" }
const _hoisted_6 = {
  key: 0,
  class: "col-12 fs-regular"
}
const _hoisted_7 = { class: "col-search" }
const _hoisted_8 = { class: "col-search__sticky" }
const _hoisted_9 = { class: "notice__block container-fluid" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { key: 0 }

import {
  computed, nextTick, onBeforeUnmount, onMounted, reactive, ref, watch,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import BaseEqualizer from '@/components/BaseEqualizer.vue';
import ProductCard from '@/components/product/PriceCard.vue';
import { Product } from '@/classes';
import { DataLayer } from '@/classes/DataLayer';
import PriceSearchCard from '@/components/PriceSearchCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceshowPage',
  setup(__props) {

const route = useRoute();
const store = useStore();
const router = useRouter();
const stickyCont = ref();
const priceshowEqualizer = ref<InstanceType<typeof BaseEqualizer>>();

const routeQueryVars = computed(() => route.query);
const routeParamVars = computed(() => route.params);

const isFetching = computed(() => store.getters['priceshow/loading']);
const products = computed(() => store.getters['priceshow/productsFiltered']);

const cartItemKey = ref(routeQueryVars.value.cik);

const priceshow = reactive({
  params: {
    productId: routeQueryVars.value.pid,
    double: routeParamVars.value.usageHt ? 1 : 0,
    usage: parseInt(`${routeParamVars.value.usage}`, 10),
    usageHt: parseInt(`${routeParamVars.value.usageHt || 0}`, 10),
    postcode: routeParamVars.value.postcode,
    city: routeQueryVars.value.stadt,
    street: routeQueryVars.value.strasse,
    houseNumber: routeQueryVars.value.hausnummer,
    branch: routeParamVars.value.branch,
    oeko: parseInt(`${routeQueryVars.value?.oeko || 0}`, 10),
    affiliateId: routeQueryVars.value?.aid,
  },
});

const productsSorted = ref<Product[]>([]);

const pushAvailableProductsToLayer = () => {
  DataLayer.push({ event: null });
  if (products.value.length <= 0) {
    DataLayer.push({
      event: 'no_tariff_available',
      customer_type: 'private',
      postcode: priceshow.params.postcode,
      consumption: priceshow.params.usage,
      energy_type: priceshow.params.branch,
    });
  } else {
    DataLayer.push({
      event: 'available_tariffs',
      customer_type: 'private',
      postcode: priceshow.params.postcode,
      consumption: priceshow.params.usage,
      offers: productsSorted.value.map((product: Product) => product.attributes.name),
      energy_type: priceshow.params.branch,
    });
  }
};

const pushCalculateToLayer = () => {
  DataLayer.push({ event: null });
  if (products.value.length <= 0) {
    DataLayer.push({
      event: 'calculate_error',
      customer_type: 'private',
      message: 'Leider konnten für Ihre Angaben aktuell keine Preise ermittelt werden.',
      postcode: priceshow.params.postcode,
      consumption: priceshow.params.usage,
      energy_type: priceshow.params.branch,
    });
  } else {
    DataLayer.push({
      event: 'calculate',
      customer_type: 'private',
      postcode: priceshow.params.postcode,
      consumption: priceshow.params.usage,
      energy_type: priceshow.params.branch,
    });
  }
};

const containsPartner = ref(false);

watch(() => products.value, () => {
  const pid: string = Array.isArray(routeQueryVars.value.pid)
    ? routeQueryVars.value.pid.join(',')
    : routeQueryVars.value.pid ?? '';

  if (pid) {
    productsSorted.value = [...products.value].filter(($pa) => pid.split(',').map(Number).includes($pa.id));
  } else {
    productsSorted.value = ([...products.value] as Product[]).sort(($pa, $pb) => {
      if (
        ($pa.isRecommended && !routeQueryVars.value.pid)
          || pid.split(',').map(Number).includes($pa.id)
      ) {
        return -1;
      }

      return $pa.getPriceValue('yearly') > $pb.getPriceValue('yearly') ? 1 : -1;
    });
  }

  const filterProductsByOeko = (productsFilter: any[], o: boolean) => productsFilter.filter((p) => p.attributes.details.contractDetails.isEco === o);

  if (routeQueryVars.value.oeko === '1') {
    productsSorted.value = filterProductsByOeko(productsSorted.value, true);
  }

  containsPartner.value = productsSorted.value.some((p) => p.id === 44);

  pushCalculateToLayer();
  pushAvailableProductsToLayer();

  nextTick(() => {
    if (priceshowEqualizer.value) {
      priceshowEqualizer.value.runEqualize();
    }
  });
});

const fetchPrices = () => {
  store.dispatch('priceshow/fetch', priceshow.params);
};

const setPriceshowParams = () => {
  priceshow.params.city = routeQueryVars.value.stadt;
  priceshow.params.street = routeQueryVars.value.strasse;
  priceshow.params.houseNumber = routeQueryVars.value.hausnummer;
  priceshow.params.branch = routeParamVars.value.branch;
  priceshow.params.postcode = routeParamVars.value.postcode;
  priceshow.params.double = routeParamVars.value.usageHt ? 1 : 0;
  priceshow.params.usage = parseInt(`${routeParamVars.value.usage}`, 10);
  priceshow.params.usageHt = parseInt(`${routeParamVars.value.usageHt || 0}`, 10);
  priceshow.params.oeko = parseInt(`${routeQueryVars.value.oeko || 0}`, 10);
  priceshow.params.productId = routeQueryVars.value.pid;
};

const showOtherBranchModalProduct = ref<Product | null>(null);

watch(() => ({
  ...routeParamVars.value,
  ...routeQueryVars.value,
}), () => {
  showOtherBranchModalProduct.value = null;
  setPriceshowParams();
  fetchPrices();
}, { deep: true });

onMounted(() => {
  fetchPrices();
});

const clickOrder = ($product: Product) => {
  store.commit('priceshow/SET_LOADING', true);

  store.dispatch('cart/add', {
    product: $product,
    cartItemKey: cartItemKey.value,
    params: priceshow.params,
    entry: true,
  }).then((response) => {
    if (response.cartEnabled) {
      router.push('/warenkorb/');
    } else {
      router.push('/bestellung/adresse/');
    }
  });
};

const setStickyTop = () => {
  const header = document.querySelector('header');
  if (stickyCont.value && header) {
    stickyCont.value.style.top = `${header.offsetHeight}px`;
  }
};

onMounted(() => {
  window.addEventListener('resize', setStickyTop);
  window.addEventListener('load', setStickyTop);
  setStickyTop();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setStickyTop);
  window.removeEventListener('load', setStickyTop);
});

return (_ctx: any,_cache: any) => {
  const _component_BasePageHeader = _resolveComponent("BasePageHeader")!
  const _component_BaseEqualizerElement = _resolveComponent("BaseEqualizerElement")!
  const _component_BaseLoader = _resolveComponent("BaseLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isFetching.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createVNode(_component_BasePageHeader, null, {
            title: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Klare Ergebnisse ")
            ])),
            subtitle: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" Unsere Tarifempfehlung ")
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(BaseEqualizer, {
                    ref_key: "priceshowEqualizer",
                    ref: priceshowEqualizer
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsSorted.value, (product, inx) => {
                        return (_openBlock(), _createBlock(_component_BaseEqualizerElement, {
                          class: "priceshow__products-card",
                          key: `product-${product.id}`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(ProductCard, {
                              product: product,
                              recommended: product.isRecommended,
                              position: inx + 1,
                              "is-single": productsSorted.value.length === 1,
                              onCart: clickOrder
                            }, null, 8, ["product", "recommended", "position", "is-single"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      (productsSorted.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Leider konnten für Ihre Angaben aktuell keine Preise ermittelt werden. "))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 512)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    ref_key: "stickyCont",
                    ref: stickyCont
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(PriceSearchCard, {
                        options: priceshow.params
                      }, null, 8, ["options"])
                    ])
                  ], 512)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (isFetching.value)
      ? (_openBlock(), _createBlock(_component_BaseLoader, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "title" }, "Hinweis", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", null, [
          _createElementVNode("b", null, "1)"),
          _createTextVNode(" Der verbrauchsabhängige Neukundenbonus wird dem Kunden mit der folgenden Jahresabrechnung einmalig ausbezahlt. Sollte der Vertrag vor Erreichen der Erstlaufzeit beendet werden, verfällt der Bonus. Voraussetzung für einen Neukundenbonus ist, dass Sie in den letzten sechs Monaten vor Abschluss des Vertrags an der vertraglichen Verbrauchsstelle nicht von uns mit Energie beliefert wurden. ")
        ], -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", null, [
          _createElementVNode("b", null, "2)"),
          _createTextVNode(" Strom: Die Preisfixierung bezieht sich auf den Arbeitspreis netto ohne Steuern, Abgaben und Umlagen sowie auf den Grundpreis netto ohne Messstellenbetrieb. Gas: Die Preisfixierung bezieht sich auf den Arbeitspreis netto ohne Steuern, Abgaben und Umlagen. Alle weiteren Preise sind Bruttopreise inkl. der gesetzlichen MwSt. Sie werden auf zwei Nachkommastellen gerundet dargestellt. ")
        ], -1)),
        _cache[5] || (_cache[5] = _createElementVNode("p", null, [
          _createElementVNode("b", null, "3)"),
          _createTextVNode(" Alle Angaben zu Versorgern und Tarifen erfolgen ohne Gewähr auf Aktualität, Vollständigkeit und Richtigkeit sowie ohne Berücksichtigung u.U. günstigerer Tarife des Grundversorgers oder evtl. Boni. Für aus fehlerhaften Daten erwachsene Schäden wird keine Haftung übernommen. Die Bedingungen der verglichenen Tarife können sich im Hinblick auf Vertragslaufzeit und Kündigungsfristen unterscheiden, bei Strom auch bzgl. Strommix. ")
        ], -1)),
        (containsPartner.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, " + der Vertrag hat eine Preisfixierung von 12 Monaten. Im Fall einer Preiserhöhung nach Ablauf der Preisfixierung wird der Kunde spätestens sechs Wochen vor Inkrafttreten über den neuen Preis informiert und erhält ein Sonderkündigungsrecht. "))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})